import React from 'react'
import { MantineProvider } from '@mantine/core'

import { CustomFonts } from '@/CustomFonts'

export const ThemeProvider: React.FC = ({ children }) => {
  return (
    <MantineProvider
      theme={{
        primaryColor: 'indigo',
        fontFamilyMonospace: 'Aeonik Mono, monospace',
        components: {
          Button: {
            styles: (theme, params) => ({
              light: {
                color: theme.colors[params.color || theme.primaryColor]?.[8],
              },
            }),
          },
          Select: {
            styles: { item: { wordBreak: 'normal' } },
          },
          MultiSelect: {
            styles: { item: { wordBreak: 'normal' } },
          },
          Stepper: {
            styles: (theme, { color }) => {
              return {
                stepIcon: {
                  '&:not([data-progress="true"]):not([data-completed="true"])':
                    {
                      backgroundColor: theme.colors.red[0],
                      border: 'none',
                      color: theme.colors.red[5],
                    },
                  '&[data-progress="true"]': {
                    backgroundColor: theme.colors.indigo[0],
                    borderColor: theme.colors.indigo[6],
                    color: theme.colors.indigo[6],
                  },
                  '&[data-completed="true"]': {
                    backgroundColor: color
                      ? theme.colors[color][6]
                      : theme.colors.indigo[6],
                    borderColor: color
                      ? theme.colors[color][6]
                      : theme.colors.indigo[6],
                  },
                },
              }
            },
          },
        },
      }}
    >
      <CustomFonts />
      {children}
    </MantineProvider>
  )
}
